module.exports = {
  baseUrl: 'https://api-v4.staging.primrose.health', //not in use
  ClinicBaseUrl: 'https://api-v4.staging.primrose.health',
  systemName: 'System dev',
  company: 'primrose',
  favicon: '../assets/favicon.png',
  companyName: 'Trillium Technologies',
  copyRight:
    'Primrose Health and Trillium Technologies are trademarks of their respective owners.',
};
